import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import style from './style/zaptic-language-sensitive-list-format-style'
import type { SupportedLanguage } from '../i18n/types.no-deps'
import { languageSensitiveListFormatter } from '../lib/listFormatting'
import sanitize from 'sanitize-html'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'

@customElement('zaptic-language-sensitive-list-format')
export class LanguageSensitiveListFormatter extends LitElement {
    static styles = style

    @property()
    translationKey?: string = ''

    @property()
    items: string[]

    @property()
    lang: SupportedLanguage

    @property({ type: 'boolean' })
    bold: boolean = false

    render() {
        const items = this.items.map((item) => {
            if (this.bold) {
                return `{{b}}${item}{{eb}}`
            }
            return item
        })

        const formatted = languageSensitiveListFormatter(items, this.lang)
        const message = window.i18n(
            sanitize(window.i18n(this.translationKey, { items: formatted }), { allowedTags: [] }),
            { b: '<strong>', eb: '</strong>' }
        )

        return html`${unsafeHTML(message)}`
    }
}
